export const PROTOCOL_TYPE = {
  acceptance: 'Acceptance',
  delivery: 'Delivery'
} as const

type ProtocolType = typeof PROTOCOL_TYPE
export type ProtocolTypes = ProtocolType[keyof ProtocolType]

export const PROTOCOL_STATUS = {
  created: 'Created',
  accepted: 'Accepted',
  handedOver: 'Handed over',
  acceptedWithComments: 'Accepted with comments'
} as const

type ProtocolStatus = typeof PROTOCOL_STATUS
export type ProtocolStatuses = ProtocolStatus[keyof ProtocolStatus]

export const KEY_TYPE = {
  frontDoor: 'Front door',
  storage: 'Storage',
  garageGate: 'Garage gate',
  box: 'Box',
  parkLift: 'Parklift',
  trashCan: 'Trash can',
  mailBox: 'Mailbox',
  entranceGate: 'Entrance gate',
  accessChip: 'Access chip'
} as const

type KeyType = typeof KEY_TYPE
export type KeyTypes = KeyType[keyof KeyType]

export const METER_TYPE = {
  coldWater: 'Cold water',
  hotWater: 'Hot water',
  heating: 'Heating',
  electricity: 'Electricity',
  airConditioning: 'Air conditioning',
  gas: 'Gas'
} as const

type MeterType = typeof KEY_TYPE
export type MeterTypes = MeterType[keyof MeterType]

export const COVERING_COST = {
  client: 'Client',
  r4r: 'R4R',
  warranty: 'Warranty'
} as const

type CoveringCost = typeof KEY_TYPE
export type CoveringCosts = CoveringCost[keyof CoveringCost]

export const SCALE_TYPE = {
  issue: 'Issue',
  noIssue: 'No issue'
} as const

type ScaleType = typeof SCALE_TYPE
export type ScaleTypes = ScaleType[keyof ScaleType]

export enum AnimalHasAnimal {
  no = 'Brak',
  yes = 'Obecne'
}

export enum AnimalType {
  dog = 'Dog',
  cat = 'Cat',
  other = 'Other'
}

export const ANIMAL_TYPE = {
  [AnimalType.dog]: 'Psy',
  [AnimalType.cat]: 'Koty',
  [AnimalType.other]: 'Inne'
}
